import { API_BASE_URL } from "../../Utills/config";

const read = async (response) => {
  if (response.ok) return response.status === 204 ? null : response.json();
  let message = "Request failed. Please try again.";
  try {
    const body = await response.json();
    message = body?.errors?.[""]?.[0] || body?.title || body?.message || message;
  } catch (_) {}
  const error = new Error(message);
  error.status = response.status;
  throw error;
};

const request = async (...args) => {
  try {
    return await read(await fetch(...args));
  } catch (error) {
    if (error instanceof TypeError) {
      throw new Error("We could not connect to the restaurant. Check your connection and try again.");
    }
    throw error;
  }
};

export const getPublicTakeawaySettings = async (restaurantId) =>
  request(`${API_BASE_URL}PublicTakeaway/${restaurantId}/settings`);

export const createPublicTakeawayOrder = async (restaurantId, order) =>
  request(`${API_BASE_URL}PublicTakeaway/${restaurantId}/orders`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(order),
  });

export const getPublicTakeawayOrder = async (restaurantId, orderId, accessToken) =>
  request(`${API_BASE_URL}PublicTakeaway/${restaurantId}/orders/${orderId}`, {
    headers: { "X-Takeaway-Access-Token": accessToken },
  });

export const createPublicTakeawayPayment = async (restaurantId, orderId, accessToken) =>
  request(`${API_BASE_URL}PublicTakeaway/${restaurantId}/orders/${orderId}/payment`, {
    method: "POST",
    headers: { "X-Takeaway-Access-Token": accessToken },
  });

export const verifyPublicTakeawayPayment = async (restaurantId, orderId, accessToken, payment) =>
  request(`${API_BASE_URL}PublicTakeaway/${restaurantId}/orders/${orderId}/payment/verify`, {
    method: "POST",
    headers: { "Content-Type": "application/json", "X-Takeaway-Access-Token": accessToken },
    body: JSON.stringify(payment),
  });

export const takeawayTrackingKey = (restaurantId, orderId) =>
  `takeaway_tracking_${restaurantId}_${orderId}`;

const takeawayOrderListKey = (restaurantId) => `takeaway_orders_${restaurantId}`;

export const getTrackedTakeawayOrderIds = (restaurantId) => {
  const storageKey = takeawayOrderListKey(restaurantId);
  const saved = localStorage.getItem(storageKey);
  if (saved) {
    try {
      const orderIds = JSON.parse(saved);
      return Array.isArray(orderIds) ? [...new Set(orderIds.filter(Boolean))] : [];
    } catch (_) {
      localStorage.removeItem(storageKey);
    }
  }

  const prefix = `takeaway_tracking_${restaurantId}_`;
  const migrated = [];
  for (let index = 0; index < localStorage.length; index += 1) {
    const key = localStorage.key(index);
    if (key?.startsWith(prefix)) migrated.push(key.slice(prefix.length));
  }
  const latest = localStorage.getItem(`takeaway_latest_${restaurantId}`);
  if (latest) migrated.push(latest);
  const orderIds = [...new Set(migrated.filter(Boolean))];
  localStorage.setItem(storageKey, JSON.stringify(orderIds));
  return orderIds;
};

export const rememberTrackedTakeawayOrder = (restaurantId, orderId, accessToken) => {
  localStorage.setItem(takeawayTrackingKey(restaurantId, orderId), accessToken);
  const orderIds = getTrackedTakeawayOrderIds(restaurantId).filter((value) => value !== orderId);
  localStorage.setItem(takeawayOrderListKey(restaurantId), JSON.stringify([orderId, ...orderIds]));
  localStorage.setItem(`takeaway_latest_${restaurantId}`, orderId);
};

export const forgetTrackedTakeawayOrder = (restaurantId, orderId) => {
  const orderIds = getTrackedTakeawayOrderIds(restaurantId).filter((value) => value !== orderId);
  localStorage.setItem(takeawayOrderListKey(restaurantId), JSON.stringify(orderIds));
};
